import React from 'react';
import { bonus } from '../data/materials';
export function BonusSection() {
  return <section className="py-10 px-4 bg-white" data-id="element-30" data-mp="1og41f5rb6r7r">
      <div className="max-w-5xl mx-auto" data-id="element-31" data-mp="1ofc5fttsurgy">
        <div className="text-center mb-8" data-id="element-32" data-mp="22fmvwvr7641l">
          <h2 className="text-[20px] md:text-2xl font-black text-[#14356B] mb-2" data-id="element-33" data-mp="22eli4jisr3g6">
            🎁 Y ADEMÁS RECIBÍS UN BONUS PREMIUM
          </h2>
          <p className="text-base font-black text-[#EE6A4D]" data-id="element-34" data-mp="1yc754g1t6xwt">
            GRATIS CON TU COMPRA
          </p>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-6 rounded-3xl p-6 bg-[#FDF8EF] border border-[#F0D3AE]" data-id="element-35" data-mp="15pw3r36dosyy">
          <div className="w-full md:w-1/2 flex justify-center" data-id="element-36" data-mp="1jhsq0qld88nf">
            <img src={bonus.image} alt="Bonus Premium: ESI para Escuela Católica" className="w-[320px] max-w-full h-auto object-contain drop-shadow-xl rounded-lg" data-id="element-37" data-mp="1eqarsaaq8m65" />
          </div>

          <div className="w-full md:w-1/2" data-id="element-38" data-mp="qy3p6teeriya">
            <span className="inline-block bg-[#F5CE3E] text-[#14356B] text-[10px] font-black tracking-wide px-3 py-1 rounded-full mb-3 uppercase" data-id="element-39" data-mp="mxtitfmpeqiw">
              🎁 Bonus Premium · Gratis
            </span>
            <h3 className="text-xl md:text-2xl font-black mb-2 text-[#14356B] leading-tight" data-id="element-40" data-mp="2eq4ly0lszqn6">
              {bonus.title}
            </h3>
            <p className="text-base font-bold text-[#157C8B] mb-2" data-id="element-41" data-mp="2jjzb3jk6gxtn">
              {bonus.pages}
            </p>
            <p className="text-lg text-gray-700 mb-3" data-id="element-42" data-mp="1qt8m615csgsw">{bonus.tagline}</p>
            <p className="text-base text-gray-600 mb-4" data-id="element-43" data-mp="1qv1t7hjvp31f">{bonus.body}</p>
            <p className="text-sm font-bold text-gray-500 uppercase tracking-wide mb-2" data-id="element-44" data-mp="1vtd3fte35fk6">
              {bonus.intro}
            </p>
            <ul className="space-y-1.5 text-base text-gray-800" data-id="element-45" data-mp="20thnfte7csf5">
              {bonus.topics.map(topic => <li key={topic} className="flex items-start" data-id="element-46" data-mp="25rsyu8k5bazh">
                  <span className="text-[#E0872F] mr-2 font-bold" data-id="element-47" data-mp="3c7d4j7oo3b90">✔</span>
                  {topic}
                </li>)}
            </ul>
            <p className="text-base font-bold text-[#14356B] mt-4" data-id="element-48" data-mp="3h3trhyk4rjki">
              {bonus.closing}
            </p>
          </div>
        </div>
      </div>
    </section>;
}